module.exports = __webpack_public_path__ + "media/Meta_Identty_02_211125_HD_Denoised_beauty.0da588d6.mp4";